export default __webpack_public_path__ + "026ee60f09353254722178dde5dd3fee.jpg";